<template>
    <div style="width:100%">      
        <el-select v-model="selectValue" multiple filterable remote  :remote-method="remoteMethod" clearable :loading="loading" 
            style="display:block;" :placeholder="$t('msg.fuzzy1WordSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')" :disabled="pOnlyView">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label"></el-option>
      </el-select>      
    </div>
</template>

<script>

import { apiFindCust } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

export default {   
    props: {      
      pSelectValue: {
        type: String
      },
      pOnlyView: {
        type: Boolean,
        default: false
      }         
    },
    data() {
      return {
        options: [],
        loading: false,
        selectValue:''
      }
    },
    watch:{
      pSelectValue(){   
        if(this.pSelectValue == null || this.pSelectValue ==''){            
            this.selectValue = '';
            this.options = [];
        }else{
          this.selectValue = CommonUtil.strToArr(this.pSelectValue);
        }
      },      
      selectValue(){
        this.$emit('sync-select-cust', this.selectValue);

      }
    },
    mounted(){      
      if(this.pSelectValue != null && this.pSelectValue !=''){
        this.selectValue = CommonUtil.strToArr(this.pSelectValue);
      }      
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          apiFindCust({ headers: authHeader(), condition:query}).then((response) => {            
            this.options = [];
            var temp = [];            
            response.data.forEach( function ( item, index, array)  {                              
              temp.push({value:item.sapCode, label: item.sortl+'('+item.sapCode+')' });
            });
            this.options = temp; 
            this.loading = false;

          }).catch((err) => {
            console.log(err);
          });
        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>